import { PostCreateSourceDataPreviewByTrialCodeAndPatientStudyNumber, SourceDataSingleResponse } from '@/api/dtos';
import { useGet, usePost } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { ISourceDataConfiguration } from '../../api/dtos';

const getData = (response?: SWRResponse<SourceDataSingleResponse, SourceDataSingleResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<SourceDataSingleResponse, SourceDataSingleResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useSourceDataPreviewByTrialCodeAndPatientStudyNumber = (trialCode?: string, patientStudyNumber?: string, sourceDataConfiguration?: ISourceDataConfiguration, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return trialCode && patientStudyNumber && sourceDataConfiguration ? 
            () => new PostCreateSourceDataPreviewByTrialCodeAndPatientStudyNumber({ trialCode, patientStudyNumber, configuration: sourceDataConfiguration }) : 
            undefined;
    }, [trialCode, patientStudyNumber, sourceDataConfiguration]);

    return usePost(request, { getData, getError}, configuration);
};

export default useSourceDataPreviewByTrialCodeAndPatientStudyNumber;